import React from "react";
import EntityList from "../EntityList/EntityList";
import swal from "sweetalert";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";

const messages = defineMessages({
  conditionsWarning: {
    id: "app.cancellationPolicyList.conditionsWarning",
    description: "This cancellation policy is being used in some conditions, it can not be deleted.",
    defaultMessage: "This cancellation policy is being used in some conditions, it can not be deleted.",
  },
  close: {
    id: "app.conditionsList.close",
    description: "Close",
    defaultMessage: "Close",
  },
  disabledDelete: {
    id: "app.conditionsList.tooltip.delete",
    description: "Message for tooltip disabled delete",
    defaultMessage: "Disabled delete",
  },
  helperText: {
    id: "app.cancellationPolicyList.helperText",
    description: "Helper text",
    defaultMessage: "Disabled delete",
  }
});

class CancellationPolicyList extends React.Component {
  constructor(props, context) {
    super(props, context);
    //Entities are copied to the state because they can change?
    // but if entities come from the parent shouldn't I change it there?
    // what will I do after an update in the list?
    // the easiest would be to just request the list once again
    // and fetch the updates
    this.state = {
      entities: [],
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  handleToggle = ({ event, field, entity }) => {
    this.props.onToggleListItem({
      id: entity.id,
      entity,
      activeProperty: "active",
    });
  };
  handleDelete = ({ event, entity }) => {
    event.preventDefault();
    event.stopPropagation();

    return this.props.onDeleteListItem({
      id: entity.id,
      entity,
    });
  };

  handleClone = params => this.props.onCloneListItem(params);

  customEntityToListValuesMapper = ({ entities, currentLocale }) => {
    return entities.map(oldEntity => {
      return { ...oldEntity, allowDelete: !oldEntity.linkedToCondition };
    });
  };

  render() {
    const { config, success } = this.props;
    const {
      name,
      entityName,
      validation,
      fields,
      renderers,
      sorting,
      allowClone,
      reorder,
    } = config;
    const { entities, loading, entityError, entityResult, handleCreate, handleEdit } = this.props;
    const { handleToggle, handleDelete } = this;
    return (
      <EntityList
        loading={loading}
        disableSorting
        entityName={entityName}
        headerHelperText={<FormattedMessage {...messages.helperText} />}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        onToggle={handleToggle}
        onDelete={handleDelete}
        onClone={this.handleClone}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        sorting={sorting}
        reorder={reorder}
        onReorder={this.props.onReorderListItem}
        success={success}
        allowClone={allowClone}
        customEntityToListValuesMapper={this.customEntityToListValuesMapper}
        customActions={[
          {
            classNames: "btn-danger disabled",
            icon: "fa fa-trash-o",
            tooltipId: "delete-custom",
            tooltipText: this.props.intl.formatMessage(messages.disabledDelete),
            onExecute: ({ event, entity, index }) => {
              swal({
                text: this.props.intl.formatMessage(messages.conditionsWarning),
                icon: "warning",
                buttons: {
                  cancel: this.props.intl.formatMessage(messages.close),
                },
                dangerMode: true,
              });
            },
            isAvailable: ({ event, entity, index }) => {
              return entity.linkedToCondition;
            },
          },
        ]}
      />
    );
  }
}

CancellationPolicyList.propTypes = {};

CancellationPolicyList.defaultProps = {
  entities: [],
};

export default injectIntl(CancellationPolicyList);
